var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteButtonActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4277,
    cy: 24.4277,
    r: 24.4277,
    fill: "#D3D3D3",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2612 16.7481C31.9421 14.4173 28.1815 14.4173 25.8611 16.7481L24.5003 18.1157L23.1394 16.7481C20.8191 14.4173 17.0585 14.4173 14.7394 16.7481C12.4202 19.0788 12.4202 22.8583 14.7394 25.1902L16.1002 26.5579L24.4997 35L32.8998 26.5579L34.2606 25.1902C36.5798 22.8589 36.5798 19.0794 34.2606 16.7481H34.2612Z",
    fill: "#FF6565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteButtonActive);
export default __webpack_public_path__ + "static/media/FavouriteButtonActive.33412afe904d188c3216070a142d1818.svg";
export { ForwardRef as ReactComponent };